const setNewWindowLocationHash = (activeFilters) => {
    let windowHash = '';
    let windowHashItems = [];
    for (const [key, item] of Object.entries(activeFilters)) {
        let myValues = [];
        if (Array.isArray(item)) {
            item.forEach(element => {
                myValues.push('"' + element.value + '"');
            });
        }
        else {
            myValues.push(item.value);
        }
        windowHashItems.push(key + "=" + myValues.join(','));
    }
    windowHash = windowHashItems.join('&');
    // KI-20
    if (windowHash.split("&").length <= 1 && windowHash.split("&").includes('type="ki"')) {
        windowHash = '';
    }

    // @TODO https://stackoverflow.com/a/14690177
    window.location.hash = windowHash;
};

export default setNewWindowLocationHash;
